(function () {
	'use strict';

	angular
		.module('recomActionPlanUpdateStatusReviewControllers')
		.controller('RecomUpdateStatusAssessByActionPlanCriteriasToReviewController', Controller);

	Controller.$inject = ['$scope', '$state', '$stateParams', '$timeout', '$mdToast', '$modal', 'notificationService', 'topBarService', 'recomActionPlanUpdateStatusService', 'govNotificationDelay', 'bUnit', 'govProcess', 'assessmentsByActionPlan', 'fiscalYearQuarterKeys'];
	function Controller($scope, $state, $stateParams, $timeout, $mdToast, $modal, notificationService, topBarService, recomActionPlanUpdateStatusService, govNotificationDelay, bUnit, govProcess, assessmentsByActionPlan, fiscalYearQuarterKeys) {

		if ($state.is('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriterias')) {

			if (fiscalYearQuarterKeys.length == 0) {
				$state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanNoCriterias',
					{
						ActionPlanID: $stateParams.ActionPlanID,
					},
					{ location: 'replace' }
				);

				return;
			}

			if (assessmentsByActionPlan.ActionPlanAssessmentSummary.UseByQuarterPaging) {
				$state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanCriteriasByQuarter',
					{
						ActionPlanID: $stateParams.ActionPlanID,
						FiscalYearQuarterKey: fiscalYearQuarterKeys[0],
					},
					{ location: 'replace' }
				);

				return;
			}
		}

		var title = bUnit.TitleEN + ' Action Plans | ' + govProcess.ShortName + ' Progress Tracking';
		topBarService.setTitleAndIcon(title, 'fa fa-road');

		$scope.actionPlan = assessmentsByActionPlan.ActionPlan;
		$scope.actionPlanStatusList = assessmentsByActionPlan.ActionPlanStatusList;
		$scope.assessmentsByActionPlan = _.omit(assessmentsByActionPlan, 'ActionPlanCriteriaAssessments');
		$scope.critAssByQuarter = _.chain(assessmentsByActionPlan.ActionPlanCriteriaAssessments)
			.groupBy('ActionPlanCriteria.TargetFiscalYearAndQuarter')
			.map(function (critAssByQuarter) {
				var mapped = {
					TargetDateQuarterShortTitleEN: critAssByQuarter[0].ActionPlanCriteria.TargetDateQuarterShortTitleEN,
					TargetFiscalYear: critAssByQuarter[0].ActionPlanCriteria.TargetFiscalYear,
					TargetFiscalYearAndQuarter: critAssByQuarter[0].ActionPlanCriteria.TargetFiscalYearAndQuarter,
					ActionPlanCriteriaAssessments: critAssByQuarter
				};

				return mapped;
			})
			.value();

		$scope.ctrlCtxt = {
		};

		// To Go Action Plan
		$scope.goToActionPlan = function () {
			if ($scope.assessmentsByActionPlan.ActionPlanAssessment.AreAllCriteriasReviewed) {
				$state.go('recomActionPlanUpdateStatusReview.actionPlans.byActionPlanAssessment', {
					ActionPlanID: $scope.actionPlan.ActionPlanID
				});

				return;
			}

			if (!$scope.isMissingAssessmentsShow) {
				$scope.isMissingAssessmentsShow = true;
				$timeout(function () {
					$scope.isMissingAssessmentsShow = false;
				}, govNotificationDelay);
			}
		};

		// Unlock Action Plan
		$scope.unlockActionPlan = function () {
			if (!$scope.assessmentsByActionPlan.ActionPlanAssessment.IsLocked) return;

			$scope.ctrlCtxt.isLoading = true;

			recomActionPlanUpdateStatusService
				.unlockActionPlanAssessment(
					$scope.actionPlan.RecomBusinessUnitID,
					$scope.actionPlan.ActionPlanID,
					$scope.assessmentsByActionPlan.ActionPlanAssessment)
				.then(function () {

					$mdToast.show(
						$mdToast
							.simple()
							.content('Action plan has been unlocked')
							.position('top right')
							.hideDelay(govNotificationDelay)
							.action('OK')
							.theme('primary')
					);

					$state.reload();
				})
				.finally(function () {
					$scope.ctrlCtxt.isLoading = false;
				});
		};

		// Lock Action Plan
		$scope.lockActionPlan = function () {
			$scope.ctrlCtxt.isLoading = true;

			recomActionPlanUpdateStatusService
				.lockActionPlanAssessment($scope.actionPlan.RecomBusinessUnitID,
					$scope.actionPlan.ActionPlanID,
					$scope.assessmentsByActionPlan.ActionPlanAssessment)
				.then(function () {
					$state.reload();
				});
		};

		$scope.editReviewComment = function () {

			// Modal to show
			var modalScope = $scope.$new(true);
			modalScope.ctrlCtxt = $scope.ctrlCtxt;
			modalScope.ctrlCtxt.actionPlanAssessment = {
				ActionPlanID: assessmentsByActionPlan.ActionPlanAssessment.ActionPlanID,
				ActionPlanAssessmentID: assessmentsByActionPlan.ActionPlanAssessment.ActionPlanAssessmentID,
				ReviewComment: assessmentsByActionPlan.ActionPlanAssessment.ReviewComment,
			};

			var showModal = $modal({
				scope: modalScope,
				template: '/app/Main/recomActionPlanStatusUpdate/review/byActionPlanAssessment.editCommentActionPlanAssessment.tpl.html',
				placement: 'center',
				backdrop: 'static'
			});

			modalScope.okModal = function (actionPlanAssessment) {
				if (!$scope.ctrlCtxt.isLoading) {
					$scope.ctrlCtxt.isLoading = true;
					recomActionPlanUpdateStatusService
						.updateActionPlanAssessmentReviewComment(
							$scope.actionPlan.ActionPlanID,
							$scope.actionPlan.RecomBusinessUnitID,
							actionPlanAssessment)
						.then(function () {
							modalScope.close();
							notificationService.notify('Action Plan Assessment Comment updated successfully');
							$state.reload();
						})
						.finally(function () {
							$scope.ctrlCtxt.isLoading = false;
						});
				}
			};

			modalScope.hideModal = function () {
				showModal.$promise.then(showModal.hide);
			};

			modalScope.close = function () {
				modalScope.hideModal();
			};
		}
	}
})();
